module.exports = __webpack_public_path__ + "static/img/isliaght.50d1795.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/light/isliaght.png
// module id = 8g+X
// module chunks = 1